define("calendar/components/calendar/multiple-bttp-trial-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="u--hide" {{did-insert this.showModal}} {{did-update this.showModal this.selectedProfileCount}} />
  {{#if this.showTryBttpModal}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Modal @close={{this.closeTrialModal}} @focusTrap={{true}} as |modal|>
        <modal.card class="cCA--tryBttp__modal qa-multiple-bttp-trial-modal">
          <modal.card-body class="cCA--tryBttp__container">
            <img
              alt={{t "bttp.trial_modal.title"}}
              class="o--media cCA--tryBttp__img"
              src="/assets/images/img--multiple-bttp.png"
            />
            <div class="cCA--tryBttp__content">
              <h2>
                {{t "bttp.trial_modal.title"}}
              </h2>
              <p class="u--text--base u--m__t__md u--m__b__lg">
                {{t "bttp.trial_modal.paragraph_1"}}
                <br />
                <br />
                {{t "bttp.trial_modal.paragraph_2"}}
              </p>
              <Shared::Ui::Button
                @additional="rounded"
                @onClick={{this.startBttpTrial}}
                @text={{t "bttp.trial_modal.button"}}
                @variant="primary"
                class="u--text--md u--text--bold cCA--tryBttp__content__button qa-multiple-bttp-trial-modal__button"
              />
            </div>
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "thQv0/rC",
    "block": "[[[11,0],[24,0,\"u--hide\"],[4,[38,0],[[30,0,[\"showModal\"]]],null],[4,[38,1],[[30,0,[\"showModal\"]],[30,0,[\"selectedProfileCount\"]]],null],[12],[13],[1,\"\\n\"],[41,[30,0,[\"showTryBttpModal\"]],[[[1,\"  \"],[8,[39,3],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,4],null,[[\"@close\",\"@focusTrap\"],[[30,0,[\"closeTrialModal\"]],true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card\"]],[[24,0,\"cCA--tryBttp__modal qa-multiple-bttp-trial-modal\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],[[24,0,\"cCA--tryBttp__container\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"img\"],[15,\"alt\",[28,[37,5],[\"bttp.trial_modal.title\"],null]],[14,0,\"o--media cCA--tryBttp__img\"],[14,\"src\",\"/assets/images/img--multiple-bttp.png\"],[12],[13],[1,\"\\n          \"],[10,0],[14,0,\"cCA--tryBttp__content\"],[12],[1,\"\\n            \"],[10,\"h2\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"bttp.trial_modal.title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--base u--m__t__md u--m__b__lg\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"bttp.trial_modal.paragraph_1\"],null]],[1,\"\\n              \"],[10,\"br\"],[12],[13],[1,\"\\n              \"],[10,\"br\"],[12],[13],[1,\"\\n              \"],[1,[28,[35,5],[\"bttp.trial_modal.paragraph_2\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,6],[[24,0,\"u--text--md u--text--bold cCA--tryBttp__content__button qa-multiple-bttp-trial-modal__button\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"rounded\",[30,0,[\"startBttpTrial\"]],[28,[37,5],[\"bttp.trial_modal.button\"],null],\"primary\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[1]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"modal\"],false,[\"did-insert\",\"did-update\",\"if\",\"shared/portal\",\"shared/modal\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/multiple-bttp-trial-modal.hbs",
    "isStrictMode": false
  });
  var ModalState = /*#__PURE__*/function (ModalState) {
    ModalState["None"] = "none";
    ModalState["TryModal"] = "try-modal";
    return ModalState;
  }(ModalState || {});
  /**
   * This component manages the 24-hour trial experience for Best Time to Post (BTTP).
   * It handles three main user states:
   * 1. Users with full BTTP access can use the feature immediately.
   * 2. Users without access see a trial modal the first time they interact with BTTP.
   * 3. Users whose 24-hour trial has expired see an upgrade prompt.
   *
   * Trial state is persisted via the cache service so it survives page reloads.
   * The component mirrors the pattern established by Calendar::FutureTrends.
   */
  let MultipleBttpTrialModalComponent = _exports.default = (_dec = (0, _service.service)('calendar/bttp'), (_class = class MultipleBttpTrialModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor3, this);
      _initializerDefineProperty(this, "bttp", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "modalState", _descriptor6, this);
    }
    get hasAcceptedTrial() {
      return this.bttp.hasAcceptedMultiBttpTrial;
    }

    /**
     * True when the user has growth or above plan
     */
    get canUseMultipleBttp() {
      return Boolean(this.auth.currentAccount.canMultipleBttp);
    }
    get selectedProfileCount() {
      return this.selectedSocialProfiles.count;
    }

    /**
     * True when the user lacks Multiple BTTP access, has already seen the trial modal,
     * and their 24-hour trial window has expired — i.e. they must upgrade.
     */
    get needsUpgrade() {
      return !this.canUseMultipleBttp && this.hasAcceptedTrial && this.bttp.multipleBttpTrialExpired;
    }

    /**
     * True when the user lacks BTTP access and has not yet seen the trial modal.
     */
    get canTryMultipleBttp() {
      return !this.canUseMultipleBttp && !this.hasAcceptedTrial;
    }
    get showTryBttpModal() {
      return this.modalState === ModalState.TryModal;
    }
    showModal() {
      const hasAlreadyAcceptedTrial = this.hasAcceptedTrial;
      const hasMoreThanOneProfileSelected = this.selectedProfileCount > 1;
      const modalIsClosed = this.modalState === ModalState.None;
      if (modalIsClosed && this.canTryMultipleBttp && hasMoreThanOneProfileSelected && !hasAlreadyAcceptedTrial && !this.bttp.userClosedMultiBttpModal && this.router.currentRouteName?.includes('calendar.index')) {
        this.segment.track('opened-multi-bttp-trial-modal');
        this.modalState = ModalState.TryModal;
      }
    }

    /**
     * Closes the trial modal and records the 24-hour expiry timestamp in the
     * cache so that subsequent visits correctly gate access.
     */
    closeTrialModal() {
      this.bttp.userClosedMultiBttpModal = true;
      this.modalState = ModalState.None;
    }

    /**
     * Confirms the user wants to start their BTTP trial, then closes the modal.
     * Exposed as a distinct action so callers can hook additional behavior here.
     */
    startBttpTrial() {
      this.bttp.startTrial();
      this.args.onTrialStart?.();
      this.closeTrialModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "modalState", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return ModalState.None;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "showModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTrialModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTrialModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startBttpTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "startBttpTrial"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MultipleBttpTrialModalComponent);
});